import React, { useState, useRef, useEffect } from 'react';

const panelStyle = {
  width: 280,
  background: '#1a1a2e',
  borderLeft: '1px solid rgba(102,126,234,0.15)',
  padding: 16,
  overflowY: 'auto',
  color: '#eee',
  fontFamily: 'sans-serif',
  borderRadius: '8px 0 0 8px',
};

const sectionStyle = {
  marginBottom: 16,
};

const sliderRow = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 6,
};

const sliderLabel = {
  fontSize: 11,
  color: '#999',
  width: 14,
  textAlign: 'center',
};

const sliderInput = {
  flex: 1,
  accentColor: '#667eea',
};

const valLabel = {
  fontSize: 11,
  color: '#ccc',
  width: 30,
  textAlign: 'right',
};

const SECTIONS = [
  { key: 'shadows', label: 'Shadows' },
  { key: 'midtones', label: 'Midtones' },
  { key: 'highlights', label: 'Highlights' },
];

const CHANNELS = [
  { key: 'r', label: 'R', color: '#ff4444' },
  { key: 'g', label: 'G', color: '#44ff44' },
  { key: 'b', label: 'B', color: '#4488ff' },
];

const INITIAL = {
  shadows_r: 0, shadows_g: 0, shadows_b: 0,
  midtones_r: 0, midtones_g: 0, midtones_b: 0,
  highlights_r: 0, highlights_g: 0, highlights_b: 0,
};

/**
 * ColorBalancePanel — auto-applies on slider change (debounced 500ms).
 */
export default function ColorBalancePanel({ editor }) {
  const [adjustments, setAdjustments] = useState({ ...INITIAL });
  const mountedRef = useRef(false);
  const timerRef = useRef(null);

  // Auto-apply debounced
  useEffect(() => {
    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      editor.colorBalance({ adjustments });
    }, 500);
    return () => clearTimeout(timerRef.current);
  }, [adjustments]);

  const handleChange = (key, value) => {
    setAdjustments((prev) => ({ ...prev, [key]: Number(value) }));
  };

  const handleReset = () => {
    setAdjustments({ ...INITIAL });
  };

  return (
    <div style={panelStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 14, color: '#ddd' }}>🎨 Color Balance</h3>
      <div style={{ fontSize: 10, color: '#555', marginBottom: 12 }}>
        Auto-applies as you adjust
      </div>

      {SECTIONS.map((section) => (
        <div key={section.key} style={sectionStyle}>
          <div style={{ fontSize: 12, fontWeight: 'bold', marginBottom: 6, color: '#aaa' }}>
            {section.label}
          </div>
          {CHANNELS.map((ch) => {
            const fieldKey = `${section.key}_${ch.key}`;
            return (
              <div key={fieldKey} style={sliderRow}>
                <span style={{ ...sliderLabel, color: ch.color }}>{ch.label}</span>
                <input
                  type="range"
                  min={-100}
                  max={100}
                  value={adjustments[fieldKey]}
                  onChange={(e) => handleChange(fieldKey, e.target.value)}
                  style={sliderInput}
                />
                <span style={valLabel}>{adjustments[fieldKey]}</span>
              </div>
            );
          })}
        </div>
      ))}

      <button
        style={{
          padding: '8px 16px', background: 'transparent', color: '#999',
          border: '1px solid #333', borderRadius: 6, cursor: 'pointer',
          fontSize: 12, width: '100%', marginTop: 4, transition: 'all 0.2s',
        }}
        onClick={handleReset}
      >
        Reset
      </button>
    </div>
  );
}
